import styled from "styled-components";
export const imageStyle = { width: "100%", display: "block", padding: "4px" };
export const gridStyle = {
  // width: "83px",
  border: "1px solid #e1e1e1",
  height: "36px",
  borderRadius: "4px",
};
export const Container = styled.div`
  width: 83px;
  border: 1px solid #e1e1e1;
  height: 36px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
`;

export const childContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Span = styled.span`
  font-family: DM Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
`;

export const LoaderContainer = styled.div`
  width: 100%;
  height: 171px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ProgressContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  &:hover > div {
    opacity: 1;
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
`;



